import { render, staticRenderFns } from "./DenominationComponent.vue?vue&type=template&id=0471989a&scoped=true"
import script from "./DenominationComponent.vue?vue&type=script&lang=js"
export * from "./DenominationComponent.vue?vue&type=script&lang=js"
import style0 from "./DenominationComponent.vue?vue&type=style&index=0&id=0471989a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0471989a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0471989a')) {
      api.createRecord('0471989a', component.options)
    } else {
      api.reload('0471989a', component.options)
    }
    module.hot.accept("./DenominationComponent.vue?vue&type=template&id=0471989a&scoped=true", function () {
      api.rerender('0471989a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/appellation/DenominationComponent.vue"
export default component.exports